<template>
  <!--
      作者：gmshop
      时间：2019-10-25
      描述：云仓-云仓管理-云仓详情-修改云仓库存
  -->
  <div>
  <el-dialog title="修改数量" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" :model="form">
      <el-form-item label="选择产品" :label-width="formLabelWidth">
        <el-row>
          <div v-if="form.product_id!=''" class="img">
            <img :src="product.image[0].file_path" width="100" height="100" />
            <span>产品ID:{{product.product_id}}</span><br>
            <span>产品名称:{{product.product_name}}</span>
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="当前礼品数量" :label-width="formLabelWidth">
        <el-input v-model="model.product_number" autocomplete="off" disabled="disabled"></el-input>
      </el-form-item>
      <el-form-item label="修改方式" :label-width="formLabelWidth">
        <el-radio-group v-model="form.edit">
          <el-radio label="inc">增加</el-radio>
          <el-radio label="dec">减少</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="修改数量"  :label-width="formLabelWidth">
        <el-input size="small" type="number" min="0" step="1" v-model="form.product_number" width="50" placeholder="请输入修改数量"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addtUser" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
  </div>
</template>

<script>
  import WarehouseApi from '@/api/warehouse.js';
  export default {
    data() {
      return {
        /*是否打开选择商品*/
        isproduct: false,
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        loading: false,
        dialogVisible: false,
        /*form表单数据*/
        product:{},
        form: {
          user_id: '',
          product_id: '',
          edit: '',
          product_number: '',
        },
      };
    },
    props: ['open_edit','model'],
    created() {
      this.form.user_id = this.model.user_id;
      this.form.product_id = this.model.product_id;
      this.form.warehouse_product_id = this.model.warehouse_product_id;
      this.product = this.model.product;
      this.dialogVisible = this.open_edit;

    },
    methods: {
      /*添加*/
      addtUser() {
        let self = this;

        let params = self.form;
        // console.log(params)
        if(!params.user_id){
            this.showMessage('无用户');
            return ;
        }
        if(!params.product_id){
            this.showMessage('请选择产品');
            return ;
        }
        if(!params.edit){
            this.showMessage('请选择修改方式');
            return ;
        }
        if(!params.product_number){
            this.showMessage('请输入修改数量');
            return ;
        }
        self.loading = true;
        WarehouseApi.edit(params, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '恭喜你，操作成功',
                type: 'success'
              });
              self.dialogFormVisible(true);
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },
      showMessage(msg='信息不能为空'){
        this.$message({
            message: msg,
            type: 'warning'
          });
      },
      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/warehouse/warehouse/dialog/Edit.vue